// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"kiosk-re-locale-select_clearfix_1W3pZ"};